import ApiEndpoints from "../../endpoints";
import type * as models from "./index.types.ts";
import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../../@bizkeytech/base/core";
import {CancelToken} from "axios";

/**@inheritDoc*/
export class PurchasePlanningController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Fetches the planning session information.
     *
     * @param request           The request to fetch the planning session.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async getInformation(request: models.GetPurchasePlanningInformationRequest, cancelToken?: CancelToken): models.GetPurchasePlanningInformationResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.purchasePlanning.getInformation,
            params: request,
            cancelToken: cancelToken,
        });
    }

    /**
     * Builds a plan based on the provided request.
     *
     * @param request           The request to build the plan.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async buildPlan(request: models.BuildPurchasePlanRequest, cancelToken?: CancelToken): models.BuildPurchasePlanResponse {
        return this.executor?.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.purchasePlanning.buildPlan,
            cancelToken: cancelToken,
            data: request,
        });
    }

    /**
     * Fetches parts by prefix.
     *
     * @param request
     * @param cancelToken
     */
    public async getPartsByPrefix(request: models.GetPurchasePlanningPartsByPrefixRequest, cancelToken?: CancelToken): models.GetPurchasePlanningPartsByPrefixResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.purchasePlanning.getPartsByPrefix,
            params: request,
            cancelToken: cancelToken,
        });
    }

    // updatePlanDetails
    /**
     * Updates the details of a plan.
     *
     * @param request           The request to update the plan details.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async updatePlanDetails(request: models.UpdatePurchasePlanDetailsRequest, cancelToken?: CancelToken): models.UpdatePurchasePlanDetailsResponse {
        return this.executor?.execute({
            method: ApiMethods.put,
            url: ApiEndpoints.purchasePlanning.updatePlanDetails,
            cancelToken: cancelToken,
            data: request,
        });
    }

    // GetSalesReport
    /**
     * Fetches the sales report.
     *
     * @param request           The request to fetch the sales report.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async getSalesReport(request: models.GetPurchasePlanningSalesReportRequest, cancelToken?: CancelToken): models.GetPurchasePlanningSalesReportResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.purchasePlanning.getSalesReport,
            params: request,
            cancelToken: cancelToken,
        });
    }


    // getWarrantyReturnDetails
    /**
     * Fetches the warranty return details.
     *
     * @param request           The request to fetch the warranty return details.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async getWarrantyReturnDetails(request: models.GetPurchasePlanningWarrantyReturnDetailsRequest, cancelToken?: CancelToken): models.GetPurchasePlanningWarrantyReturnDetailsResponse {
        return this.executor?.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.purchasePlanning.getWarrantyReturnDetails,
            data: request,
            cancelToken: cancelToken,
        });
    }
}


export type * from './index.types.ts';
export default PurchasePlanningController;